import { render, staticRenderFns } from "./PriceCalculatorSmall.vue?vue&type=template&id=ac136184&"
import script from "./PriceCalculatorSmall.vue?vue&type=script&lang=js&"
export * from "./PriceCalculatorSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports